// Which past-images pricelist sells a given past photo.
//
// ONE implementation, because the rule is not obvious from the data: a
// past-images pricelist's `season` is a season TYPE with no year on it
// ('fall', 'spring', 'grad', 'seniors'), while a student_image's `folder`
// carries the year ('fall2026'). The match is therefore a substring test, not
// an equality one -- comparing them with === silently sells nothing at all.
//
// Used by the legacy prior-season pitch (PastImageItems) and by the Quick Order
// screen's "View Packages" link, which must land on the same pricelist the
// pitch would have opened.
export default function pastImagesPricelistFor(studentImage, pricelists) {
  const folder = studentImage && studentImage.folder;
  if (!folder) return null;

  return (pricelists || []).find((pricelist) => (
    pricelist && pricelist.season && folder.includes(pricelist.season)
  )) || null;
}
